import { render } from "./ChangePlanDialog.vue?vue&type=template&id=c0820620&scoped=true"
import script from "./ChangePlanDialog.vue?vue&type=script&lang=js"
export * from "./ChangePlanDialog.vue?vue&type=script&lang=js"

import "./ChangePlanDialog.vue?vue&type=style&index=0&id=c0820620&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0820620"]])

export default __exports__